import {
  createColumn,
  createCheckboxColumn,
  createDropdownColumn
} from "../components/Table/Table";

// Common columns used in all submenus
const commonFaultsColumn: State.Column[] = [
  createDropdownColumn(
    "Domain",
    (fault: Api.AnyItem) => fault.commonExtra.domainName,
    "fault.commonExtra.domainName",
    true,
    110
  ),
  createColumn("Code", (fault: Api.BaseFault) => Number(fault.code), "fault.code", true, 80),
  createDropdownColumn(
    "Priority",
    (fault: Api.AnyItem) => fault.commonExtra.priorityName,
    "fault.commonExtra.priorityName",
    true,
    110
  ),
  createColumn("Name", (fault: Api.BaseFault) => fault.name, "fault.name", true)
];

// Date and User columns common
export const faultsDateUserColumn: State.Column[] = [
  createColumn("Created By", (fault: Api.AnyItem) => fault.createdBy, "fault.createdBy", false),
  createColumn(
    "Created Date",
    (fault: Api.AnyItem) => fault.createdDate,
    "fault.createdDate",
    false
  ),
  createColumn("Modified By", (fault: Api.AnyItem) => fault.modifiedBy, "fault.modifiedBy", false),
  createColumn(
    "Modified Date",
    (fault: Api.AnyItem) => fault.modifiedDate,
    "fault.modifiedDate",
    false
  )
];

// Columns in Lift Faults submenu
export const liftFaultsColumns: State.Column[] = [
  ...commonFaultsColumn,
  createColumn(
    "Add. Info",
    (fault: Api.LiftFault) => fault.additionalInfoDef,
    "fault.additionalInfoDef",
    true
  ),
  createColumn("Detection", (fault: Api.BaseFault) => fault.detection, "fault.detection", true),
  createColumn("Operation", (fault: Api.BaseFault) => fault.operation, "fault.operation", true),
  createColumn("Recovery", (fault: Api.BaseFault) => fault.recovery, "fault.recovery", true),
  createColumn(
    "English name",
    (fault: Api.LiftFault) => fault.englishName,
    "fault.englishName",
    true
  ),
  createColumn("Reason", (fault: Api.LiftFault) => fault.reason, "fault.reason", true),
  createColumn("Action", (fault: Api.LiftFault) => fault.action, "fault.action", true),
  createCheckboxColumn(
    "Setup req.",
    (fault: Api.LiftFault) => fault.setupReq,
    "fault.setupReq",
    true
  ),
  createCheckboxColumn(
    "Manual reset",
    (fault: Api.LiftFault) => fault.manualReset,
    "fault.manualReset",
    true
  ),
  createCheckboxColumn(
    "No starts",
    (fault: Api.LiftFault) => fault.startPrevented,
    "fault.startPrevented",
    true
  ),
  createCheckboxColumn("SC Open", (fault: Api.LiftFault) => fault.scOpen, "fault.scOpen", true),
  createCheckboxColumn(
    "Change Board",
    (fault: Api.LiftFault) => fault.changeBoard,
    "fault.changeBoard",
    true
  ),
  createDropdownColumn(
    "DataAct Category",
    (fault: Api.AnyItem) => fault.extra.dataActName,
    "fault.extra.dataActName",
    true,
    110
  ),
  createDropdownColumn(
    "GrandNorm Category",
    (fault: Api.AnyItem) => fault.extra.grandNormName,
    "fault.extra.grandNormName",
    true,
    110
  ),
  ...faultsDateUserColumn
];

// Columns in Lift Faults submenu
export const apmFaultsColumns: State.Column[] = [
  ...commonFaultsColumn,
  createColumn(
    "Add. Info",
    (fault: Api.APMFault) => fault.additionalInfoDef,
    "fault.additionalInfoDef",
    true
  ),
  createColumn("Detection", (fault: Api.BaseFault) => fault.detection, "fault.detection", true),
  createColumn("Operation", (fault: Api.BaseFault) => fault.operation, "fault.operation", true),
  createColumn("Recovery", (fault: Api.BaseFault) => fault.recovery, "fault.recovery", true),
  createColumn(
    "English name",
    (fault: Api.APMFault) => fault.englishName,
    "fault.englishName",
    true
  ),
  createColumn("Reason", (fault: Api.APMFault) => fault.reason, "fault.reason", true),
  createColumn("Action", (fault: Api.APMFault) => fault.action, "fault.action", true),
  createCheckboxColumn(
    "Setup req.",
    (fault: Api.APMFault) => fault.setupReq,
    "fault.setupReq",
    true
  ),
  createCheckboxColumn(
    "Manual reset",
    (fault: Api.APMFault) => fault.manualReset,
    "fault.manualReset",
    true
  ),
  createCheckboxColumn(
    "No starts",
    (fault: Api.APMFault) => fault.startPrevented,
    "fault.startPrevented",
    true
  ),
  createCheckboxColumn("SC Open", (fault: Api.APMFault) => fault.scOpen, "fault.scOpen", true),
  createCheckboxColumn(
    "Change Board",
    (fault: Api.APMFault) => fault.changeBoard,
    "fault.changeBoard",
    true
  ),
    createDropdownColumn(
    "DataAct Category",
    (fault: Api.AnyItem) => fault.extra.dataActName,
    "fault.extra.dataActName",
    true,
    110
  ),
  ...faultsDateUserColumn
];

// Columns in Drive Faults submenu
export const driveFaultsColumns: State.Column[] = [
  ...commonFaultsColumn,
  createColumn("Comment", (fault: Api.DriveFault) => fault.comment, "fault.comment", true),
  createColumn(
    "Data 1",
    (fault: Api.DriveFault) => fault.data1Description,
    "fault.data1Description",
    true
  ),
  createColumn(
    "Data 2",
    (fault: Api.DriveFault) => fault.data2Description,
    "fault.data2Description",
    true
  ),
  createColumn("Detection", (fault: Api.DriveFault) => fault.detection, "fault.detection", true),
  createColumn("Operation", (fault: Api.DriveFault) => fault.operation, "fault.operation", true),
  createColumn("Recovery", (fault: Api.DriveFault) => fault.recovery, "fault.recovery", true),
  createColumn("Testing", (fault: Api.DriveFault) => fault.testing, "fault.testing", true),
  createColumn(
    "English name",
    (fault: Api.DriveFault) => fault.englishName,
    "fault.englishName",
    true
  ),
  createColumn("Reason", (fault: Api.DriveFault) => fault.reason, "fault.reason", true),
  createColumn("Action", (fault: Api.DriveFault) => fault.action, "fault.action", true),
  createCheckboxColumn(
    "Localizable",
    (fault: Api.DriveFault) => fault.localizable,
    "fault.localizable",
    true
  ),
  ...faultsDateUserColumn
];

// Columns in Group Faults submenu
export const groupFaultsColumns: State.Column[] = [
  ...commonFaultsColumn,
  createColumn("Recovery", (fault: Api.GroupFault) => fault.recovery, "fault.recovery", true),
  createColumn("Operation", (fault: Api.GroupFault) => fault.operation, "fault.operation", true),
  createColumn("Enumerations", (fault: Api.GroupFault) => fault.enumName, "fault.enumName", true),
  createColumn(
    "Release Status",
    (fault: Api.GroupFault) => fault.releaseStatus,
    "fault.releaseStatus",
    true
  ),
  createColumn(
    "English name",
    (fault: Api.GroupFault) => fault.englishName,
    "fault.englishName",
    true
  ),
  createColumn("Reason", (fault: Api.GroupFault) => fault.reason, "fault.reason", true),
  createColumn("Action", (fault: Api.GroupFault) => fault.action, "fault.action", true),
  ...faultsDateUserColumn
];

// Columns in Network Faults submenu
export const networkFaultsColumns: State.Column[] = [
  ...commonFaultsColumn,
  createColumn("Comment", (fault: Api.NetworkFault) => fault.comment, "fault.comment", true),
  createColumn(
    "Data 1",
    (fault: Api.NetworkFault) => fault.data1Description,
    "fault.data1Description",
    true
  ),
  createColumn(
    "Data 2",
    (fault: Api.NetworkFault) => fault.data2Description,
    "fault.data2Description",
    true
  ),
  createColumn("Detection", (fault: Api.NetworkFault) => fault.detection, "fault.detection", true),
  createColumn("Operation", (fault: Api.NetworkFault) => fault.operation, "fault.operation", true),
  createColumn("Recovery", (fault: Api.NetworkFault) => fault.recovery, "fault.recovery", true),
  createColumn("Testing", (fault: Api.NetworkFault) => fault.testing, "fault.testing", true),
  createColumn(
    "English name",
    (fault: Api.NetworkFault) => fault.englishName,
    "fault.englishName",
    true
  ),
  createColumn("Reason", (fault: Api.NetworkFault) => fault.reason, "fault.reason", true),
  createColumn("Action", (fault: Api.NetworkFault) => fault.action, "fault.action", true),
  ...faultsDateUserColumn
];

// Columns in Monitoring Faults submenu
export const monitoringFaultsColumns: State.Column[] = [
  ...commonFaultsColumn,
  createColumn("Comment", (fault: Api.MonitoringFault) => fault.comment, "fault.comment", true),
  createColumn(
    "Data 1",
    (fault: Api.MonitoringFault) => fault.data1Description,
    "fault.data1Description",
    true
  ),
  createColumn(
    "Data 2",
    (fault: Api.MonitoringFault) => fault.data2Description,
    "fault.data2Description",
    true
  ),
  createColumn(
    "Data 3",
    (fault: Api.MonitoringFault) => fault.data3Description,
    "fault.data3Description",
    true
  ),
  createColumn(
    "Data 4",
    (fault: Api.MonitoringFault) => fault.data4Description,
    "fault.data4Description",
    true
  ),
  createColumn("Detection", (fault: Api.MonitoringFault) => fault.detection, "fault.detection", true),
  createColumn("Operation", (fault: Api.MonitoringFault) => fault.operation, "fault.operation", true),
  createColumn("Recovery", (fault: Api.MonitoringFault) => fault.recovery, "fault.recovery", true),
  createDropdownColumn(
    "Fault Category",
    (fault: Api.MonitoringFault) => fault.extra?.faultCategoryName,
    "fault.extra.faultCategoryName",
    true,
    110
  ),
  createCheckboxColumn(
    "Localizable",
    (fault: Api.MonitoringFault) => fault.localizable,
    "fault.localizable",
    true
  ),
  createCheckboxColumn(
    "Supervision Adjustable",
    (fault: Api.MonitoringFault) => fault.supervisionAdjustable,
    "fault.supervisionAdjustable",
    true
  ),
  createColumn(
    "English name",
    (fault: Api.MonitoringFault) => fault.englishName,
    "fault.englishName",
    true
  ),
  createColumn("Reason", (fault: Api.MonitoringFault) => fault.reason, "fault.reason", true),
  createColumn("Action", (fault: Api.MonitoringFault) => fault.action, "fault.action", true),
  ...faultsDateUserColumn
];

// Columns in Monitoring Fault Categories submenu
export const monitoringFaultCategoriesColumns: State.Column[] = [
  createColumn("Code", (faultCategory: Api.FaultCategory) => Number(faultCategory.enumValue), "faultCategory.enumValue", true),
  createColumn("Enumeration", (faultCategory: Api.FaultCategory) => faultCategory.enumName, "faultCategory.enumName", true),
  createColumn("Name", (faultCategory: Api.FaultCategory) => faultCategory.name, "faultCategory.name", true),
  createColumn("Comment", (faultCategory: Api.FaultCategory) => faultCategory.comment, "faultCategory.comment", true),
  ...faultsDateUserColumn
];

// Columns in NonKone Faults submenu
export const nonKoneFaultsColumns: State.Column[] = [...commonFaultsColumn,...faultsDateUserColumn];

// Columns in Escalator Faults submenu
export const escalatorFaultsColumns: State.Column[] = [
  ...commonFaultsColumn,
  createColumn("Comment", (fault: Api.EscalatorFault) => fault.comment, "fault.comment", true),
  createColumn(
    "Data 1",
    (fault: Api.EscalatorFault) => fault.data1Description,
    "fault.data1Description",
    true
  ),
  createColumn(
    "Data 2",
    (fault: Api.EscalatorFault) => fault.data2Description,
    "fault.data2Description",
    true
  ),
  createColumn(
    "Data 3",
    (fault: Api.EscalatorFault) => fault.data3Description,
    "fault.data3Description",
    true
  ),
  createColumn(
    "Data 4",
    (fault: Api.EscalatorFault) => fault.data4Description,
    "fault.data4Description",
    true
  ),
  createColumn("Detection", (fault: Api.BaseFault) => fault.detection, "fault.detection", true),
  createColumn("Operation", (fault: Api.BaseFault) => fault.operation, "fault.operation", true),
  createColumn("Recovery", (fault: Api.BaseFault) => fault.recovery, "fault.recovery", true),
  createColumn("Enumerations", (fault: Api.EscalatorFault) => fault.enumName, "fault.enumName", true),
  createColumn(
    "English name",
    (fault: Api.EscalatorFault) => fault.englishName,
    "fault.englishName",
    true
  ),
  createColumn("Reason", (fault: Api.EscalatorFault) => fault.reason, "fault.reason", true),
  createColumn("Action", (fault: Api.EscalatorFault) => fault.action, "fault.action", true),
  createColumn("Testing", (fault: Api.EscalatorFault) => fault.testing, "fault.testing", true),
  createCheckboxColumn(
    "Setup req.",
    (fault: Api.EscalatorFault) => fault.setupReq,
    "fault.setupReq",
    true
  ),
  createCheckboxColumn(
    "Manual reset",
    (fault: Api.EscalatorFault) => fault.manualReset,
    "fault.manualReset",
    true
  ),
  createCheckboxColumn(
    "No starts",
    (fault: Api.EscalatorFault) => fault.startPrevented,
    "fault.startPrevented",
    true
  ),
  createCheckboxColumn(
    "SC Open",
    (fault: Api.EscalatorFault) => fault.scOpen,
    "fault.scOpen",
    true
  ),
  createCheckboxColumn(
    "Change Board",
    (fault: Api.EscalatorFault) => fault.changeBoard,
    "fault.changeBoard",
    true
  ),
  createDropdownColumn(
    "DataAct",
    (fault: Api.AnyItem) => fault.extra.dataActName,
    "fault.extra.dataActName",
    true,
    110
  ),
  ...faultsDateUserColumn
];

// Columns in Door Faults submenu
export const doorFaultsColumns: State.Column[] = [
  ...commonFaultsColumn,
  createColumn("Detection", (fault: Api.BaseFault) => fault.detection, "fault.detection", true),
  createColumn("Operation", (fault: Api.BaseFault) => fault.operation, "fault.operation", true),
  createColumn("Recovery", (fault: Api.BaseFault) => fault.recovery, "fault.recovery", true),
  createColumn(
    "English name",
    (fault: Api.LiftFault) => fault.englishName,
    "fault.englishName",
    true
  ),
  createColumn("Reason", (fault: Api.LiftFault) => fault.reason, "fault.reason", true),
  createColumn("Action", (fault: Api.LiftFault) => fault.action, "fault.action", true),
  createColumn("Enumerations", (fault: Api.DoorFault) => fault.enumName, "fault.enumName", true),
  ...faultsDateUserColumn
];

// Columns in Signalization Faults submenu
export const signalizationFaultsColumns: State.Column[] = [ 
  ...commonFaultsColumn,
  createColumn("Detection", (fault: Api.BaseFault) => fault.detection, "fault.detection", true),//check its ok to use BaseFault here
  createColumn("Operation", (fault: Api.BaseFault) => fault.operation, "fault.operation", true),
  createColumn("Recovery", (fault: Api.BaseFault) => fault.recovery, "fault.recovery", true),  
  createColumn("Enumerations", (fault: Api.SignalizationFault) => fault.enumName, "fault.enumName", true),
  createColumn("Release Status", (fault: Api.SignalizationFault) => fault.releaseStatus, "fault.releaseStatus", true),
  createColumn("English name",(fault: Api.SignalizationFault) => fault.englishName,"fault.englishName", true),
  createColumn("Reason", (fault: Api.SignalizationFault) => fault.reason, "fault.reason", true),
  createColumn("Action", (fault: Api.SignalizationFault) => fault.action, "fault.action", true),
  ...faultsDateUserColumn
];//what fields to show in table and change the order if needed